<template>
        <bita-modal
                :id="modalId"
                :title="title"
                :modal-lg="true"
                :isLoading="isLoading"
        >
            <div slot="body">
                <bita-form ref="form">
                    <div slot="body"></div>
                </bita-form>
            </div>
            <div slot="footer">
                <bita-bootbutton
                        class="mr-2"
                        type="danger"
                        title="بستن"
                        icon="fas fa-times"
                        btn-width="150px"
                        data-dismiss="modal"
                />
            </div>
        </bita-modal>
</template>
<script>
    import Spinner from "../../components/Spinner";
    export default {
        components: {Spinner},
        props:{
            isLoading:{},
            modalId:{},
            title:{},
        },
        data() {
            return {
            }
        }
    }
</script>